import React from 'react';
import OeTip from './OeTip';

/**
 * Warnband, wenn der Beleg in weclapp geändert wurde, während hier
 * ungespeicherte Änderungen offen sind (Original `#stalebar` HTML 686 und
 * `showStaleBanner` 2011).
 *
 * Ohne eigene Änderungen wird der neue Stand still nachgezogen — dieses Band
 * erscheint nur beim echten Konflikt, weil dann eine Entscheidung nötig ist:
 * eigene Eingaben verwerfen oder den fremden Stand ignorieren.
 *
 * @param {boolean} show
 * @param {() => void} onReload - Verwerfen und neu laden.
 * @param {() => void} onDismiss
 */
export default function StaleBanner({show, onReload, onDismiss}) {
    if (!show) {
        return null;
    }

    return (
        <div className="warnbar show" role="alert">
            <span>
                ⚠ Der Beleg wurde in weclapp geändert (anderer Nutzer oder n8n) — du hast ungespeicherte Änderungen.
            </span>
            <span className="sp"/>
            <OeTip tip="Verwirft deine ungespeicherten Änderungen und lädt den Beleg frisch aus weclapp. Dauert ein paar Sekunden.">
                <button type="button" className="primary" onClick={onReload}>Verwerfen &amp; neu laden</button>
            </OeTip>
            <OeTip tip="Blendet den Hinweis aus. Deine Änderungen bleiben; beim Speichern gewinnt dein Stand für die geänderten Felder.">
                <button type="button" onClick={onDismiss}>Ignorieren</button>
            </OeTip>
        </div>
    );
}
